import { ComponentType } from 'react';
import throwError from '../error/_throwError';

export default function excludePropsByComponent<
  Props extends Record<string, unknown>
>(props: Props, ...Components: (ComponentType<any> & { publicProps: string[]})[]) {
  return Components.reduce((result, Component) => {
    if (!Component.publicProps) {
      throwError('excludePropsByComponent: Component passed must have a "publicProps" static prop.');
    }

    Component.publicProps.forEach((propName) => {
      if (typeof result[propName] !== 'undefined') {
        delete result[propName];
      }
    });

    return result;
  }, { ...props });
}
